import Cookies from 'js-cookie';

import { Api_routes, server_url } from '../config/API_Routes';
import { getRequest } from '../config/axios-config';

const checkPassword = (password, re_password) => {
  if (password === re_password && password !== '') return true;
  else return false;
};

const validateEmail = (email) => {
  if (
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
      email
    )
  ) {
    return true;
  }
  return false;
};

const setStorage = (data, value) => {
  localStorage.setItem(data, value);
};

const getStorage = (data) => {
  return localStorage.getItem(data);
};

const removeStorage = (data) => {
  localStorage.removeItem(data);
};

const isAuthenticated = () => {
  const userToken = getStorage('token');
  const isTokenInCookies = Cookies.get('access_token');
  if (userToken && isTokenInCookies) {
    return true;
  } else {
    removeStorage('token');
    Cookies.remove('access_token');
  }
  return false;
};

const checkFeatureFlag = async () => {
  if (import.meta.env.REACT_APP_IS_FEATURE_ACTIVE === 'true') {
    return true;
  }
  const response = await getRequest(
    server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.isBetaUser
  );
  if (response?.status && response?.data?.isBetaUser) {
    return true;
  }
  return false;
};

export const blockNavigation = (userDetails) => {
  return userDetails?.paymentMethodAdded === false;
};

// This function is used to get condition for discovery blocked
const blockedUsers = ['shubh+facebook@getsaral.com', 'atharva+1@getsaral.com'];
const isDiscoveryBlockedHardcoded = (userDetails) => {
  return userDetails?.email ? blockedUsers.includes(userDetails?.email) : false;
};

export const getIsUserOnLitePlan = (userDetails) => {
  return userDetails?.plan?.name?.includes('lite') || false;
};

export {
  checkPassword,
  validateEmail,
  setStorage,
  getStorage,
  isAuthenticated,
  removeStorage,
  checkFeatureFlag,
  isDiscoveryBlockedHardcoded,
};
